import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (mapper) {
  return function (WrappedComponent) {
    var hoc = function hoc(props) {
      if (typeof mapper === 'function') {
        props = _objectSpread(_objectSpread({}, props), mapper(props));
      } else if (typeof mapper === 'object') {
        props = Object.keys(mapper).reduce(function (acc, k) {
          acc[k] = mapper[k](acc[k]);
          return acc;
        }, _objectSpread({}, props));
      }
      return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({}, props));
    };
    hoc.displayName = "WithPropMapper(".concat(getDisplayName(WrappedComponent), ")");
    return hoc;
  };
});
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
//# sourceMappingURL=withPropMapper.js.map